import service from "@/utils/axios-request";
import apiConstants from "@/utils/api-constants";
// import mockService from "@/utils/mock-axios-request";

export default {
  getMemberId(requestId) {
    return service.post(apiConstants.GET_MEMBER_ID, { requestId });
  },

  login(data) {
    // return service.get(apiConstants.LOGIN_API, data); // fake json
    return service.post(apiConstants.LOGIN_API, data); // real request
  },

  changePassword(data) {
    // return service.get(apiConstants.CHANGE_PASSWORD_API, data); // fake json
    return service.post(apiConstants.CHANGE_PASSWORD_API, data); // real request
  },

  getPublicKeyToken(data) {
    return service.get(apiConstants.PUBLIC_KEY_API, { params: { requestId: data } });
  },

  forgotPassword(data) {
    return service.post(apiConstants.FORGOT_PASSWORD, data);
  },

  signup(data) {
    return service.post(apiConstants.SIGNUP, data); // real request
  },

  viewProfile(data) {
    return service.post(apiConstants.VIEW_PROFILE, data);
  },

  deleteAccount(data) {
    return service.post(apiConstants.DELETE_ACCOUNT, data);
  },

  logout(data) {
    return service.post(apiConstants.LOGOUT, data);
  },

  isamError() {
    return service.get(apiConstants.ISAM_ERROR);
  },

  getToken() {
    return service.get(apiConstants.GET_TOKEN);
  },

  getErrorCode() {
    return service.get(apiConstants.GET_ERROR_CODE);
  },

  getSystemDowntime() {
    return service.get(apiConstants.DOWNTIME_URL);
  },
};
